import React, { useCallback, useContext, useEffect, useState } from "react";
import { useParams, Link, useLocation } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import BreadcrumbHeader from "components/common/BreadcrumbHeader";
import OrderDetailsContainer from "components/orders/orderDetails/OrderDetailsContainer";
import { AppContext, GetAppContext } from "services/appContext/AppContext";
import { useProfileSwitcher } from "services/customHooks/useProfileSwitcher";
import { DefaultOrder, OrderDto } from "services/apis/types/order/OrderDto";

export default function WorkQueueDetails() {
  let { id }: any = useParams();

  const [appContext] = useState(GetAppContext());
  const getTenant = useCallback(()=> id?.split("-")[0],[id]);
  const needToSwitchProfile = useCallback(()=>appContext?.localStorageInfo?.selectedProfile?.spId !== id ?? false,[appContext, id]);
  const {navigate: switchProfile} = useProfileSwitcher();
  const location = useLocation();
  const { appContext: context } = useContext(AppContext);
  const theme = context.theme;
  const [order, setOrder] = useState<OrderDto>(DefaultOrder);

  const handleOrderFetched = useCallback((fetchedOrder: OrderDto) => {
    setOrder(fetchedOrder);
  }, []);

  useEffect(()=> {
    if (needToSwitchProfile()){
      switchProfile(`/WorkQueue/${id}`, getTenant(), order.companyId);
    }
  },[location, id, getTenant, needToSwitchProfile, switchProfile, order]);

  return (
    <>
      <BreadcrumbHeader>
        <Link to={"/WorkQueue"}>
          <span className={`${theme === "light" ? "lblue-color" : "text-white"}`}>
            <FormattedMessage id="workQueue.title" />
          </span>
        </Link>
        <span className={`${theme === "light" ? "lblue-color" : "text-white"}`}>
          <FormattedMessage id="orders.orderDetails.breadcrumb" values={{ id }} />
        </span>
      </BreadcrumbHeader>
      <OrderDetailsContainer orderId={id} onOrderFetched={handleOrderFetched} />
    </>
  );
}
